import { useContext } from "react";
import { store } from "../App";

const BASE_URL = "https://imsdev.akrais.com:8444";
const API_KEY = "PMSProdWebAPI";
const API_REPORTS = "AKRAReportProdAPI";

async function FetchDataTypes(paramName, client, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("ClientID", client);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    RequestType: `${paramName}`,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  return await fetch(`${BASE_URL}/${API_KEY}/api/dashboards`, requestOptions);
}

async function FetchTradeOrders(startTIme, closeTIme, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    //RequestType: `${paramName}`,
    FromEnteredTime: `${startTIme}`,
    ToEnteredTime: `${closeTIme}`,
    //Status:  `${status}`,
    userID: 1,
    clientID: 1,
  });

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    //body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/tdameritrade/orders?accountId=275353556&maxResults=100&fromEnteredTime=${startTIme}&toEnteredTime=${closeTIme}`,
    requestOptions,
  );
}

async function FetchOpenTradeOrders(startTIme, closeTIme, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    //RequestType: `${paramName}`,
    FromEnteredTime: `${startTIme}`,
    ToEnteredTime: `${closeTIme}`,
    //Status:  `${status}`,
    userID: 1,
    clientID: 1,
  });

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    //body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/tdameritrade/orders?accountId=275353556&maxResults=100&fromEnteredTime=${startTIme}&toEnteredTime=${closeTIme}&status=WORKING`,
    requestOptions,
  );
}

async function FetchSecurityMaster(paramName, client, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("ClientID", client);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    RequestParamType: `${paramName}`,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  return await fetch(`${BASE_URL}/${API_KEY}/api/data`, requestOptions);
}

async function postTrades(paramName, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    RequestType: `${paramName}`,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  return await fetch(
    "${BASE_URL}/${API_KEY}/api/tdameritrade/275353556/orders",
    requestOptions,
  );
}

async function postNewTrades(paramName, token) {
  var raw = JSON.stringify(paramName);

  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: raw,
    redirect: "follow",
  };
  return await fetch(
    "${BASE_URL}/${API_KEY}/api/tdameritrade/275353556/orders",
    requestOptions,
  );
}

async function MetaDataList(token) {
  //var raw = JSON.stringify(paramName);

  var requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    //body: raw,
    redirect: "follow",
  };
  const response = await fetch(
    `${BASE_URL}/${API_KEY}/api/metadata`,
    requestOptions,
  );
  const data = await response.json();
  return data;
}

async function MetaDataDetails(selectedId, token) {
  //var raw = JSON.stringify(paramName);

  var requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    //body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/metadata/${selectedId}/parameters`,
    requestOptions,
  );
}

async function MetaDataDetailsExecute(selectedName, selectedDate, token) {
  var raw = JSON.stringify({
    date: `${selectedDate}`,
  });

  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/metadata/${selectedName}/execute`,
    requestOptions,
  );
}

async function MetaDataDetailsDownload(selectedName, getTaskDownload, token) {
  var raw = JSON.stringify({
    Type: `${getTaskDownload}`,
  });

  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: raw,
    redirect: "follow",
    responseType: "blob", // Important
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/metadata/${selectedName}/download`,
    requestOptions,
  );
}

async function GetForgotPassword(email) {
  var raw = JSON.stringify({
    email: `${email}`,
  });

  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/forgotpassword`,
    requestOptions,
  ).then((response) => response);
}

async function GetResetPassword(email, createPassword, confirmPassword, token) {
  var raw = JSON.stringify({
    password: `${createPassword}`,
    confirmPassword: `${confirmPassword}`,
    email: `${email}`,
    token: `${token}`,
  });

  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/resetpassword`,
    requestOptions,
  );
}

async function GetChangePassword(
  currentPassword,
  newPassword,
  confirmPassword,
  token,
) {
  var raw = JSON.stringify({
    currentPassword: `${currentPassword}`,
    password: `${newPassword}`,
    confirmPassword: `${confirmPassword}`,
  });

  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/changepassword`,
    requestOptions,
  );
}

async function CreateUser(email, firstName, lastName, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    email: `${email}`,
    firstName: `${firstName}`,
    lastName: `${lastName}`,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  return await fetch(
    "${BASE_URL}/${API_KEY}/api/users/register",
    requestOptions,
  );
}

async function UpdateUser(id, firstName, lastName, phoneNumber, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    firstName: `${firstName}`,
    lastName: `${lastName}`,
    phoneNumber: `${phoneNumber}`,
  });

  var requestOptions = {
    method: "PUT",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  return await fetch(`${BASE_URL}/${API_KEY}/api/users/${id}`, requestOptions);
}

async function GetUsersList(token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    //body: raw,
    redirect: "follow",
  };
  return await fetch("${BASE_URL}/${API_KEY}/api/users", requestOptions);
}

async function getUserTestList(token) {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    //body: raw,
    redirect: "follow",
  };
  const response = await fetch(
    "${BASE_URL}/${API_KEY}/api/users",
    requestOptions,
  );
  const data = await response.json();
  return data;
}

async function deleteUser(id, token) {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    id: `${id}`,
  });

  var requestOptions = {
    method: "DELETE",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const response = await fetch(
    `${BASE_URL}/${API_KEY}/api/users/${id}`,
    requestOptions,
  );
  const data = await response;
  return data;
}

async function activateUser(id, status, token) {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var requestOptions = {
    method: "PUT",
    headers: myHeaders,
    //body: raw,
    redirect: "follow",
  };
  const response = await fetch(
    `${BASE_URL}/${API_KEY}/api/users/${id}/status?enable=${status}`,
    requestOptions,
  );
  const data = await response;
  return data;
}

async function getTradeList(startTIme, closeTIme, token) {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    //body: raw,
    redirect: "follow",
  };
  const response = await fetch(
    `${BASE_URL}/${API_KEY}/api/tdameritrade/orders?accountId=275353556&maxResults=100&fromEnteredTime=${startTIme}&toEnteredTime=${closeTIme}`,
    requestOptions,
  );
  const data = await response.json();
  return data;
}

async function getOpenTradeOrdersList(startTIme, closeTIme, token) {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");
  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    //body: raw,
    redirect: "follow",
  };
  const response = await fetch(
    `${BASE_URL}/${API_KEY}/api/tdameritrade/orders?accountId=275353556&maxResults=100&fromEnteredTime=${startTIme}&toEnteredTime=${closeTIme}&status=WORKING`,
    requestOptions,
  );
  const data = await response.json();
  return data;
}

async function updateLockStatus(id, token) {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");
  var requestOptions = {
    method: "PUT",
    headers: myHeaders,
    //body: raw,
    redirect: "follow",
  };
  const response = await fetch(
    `${BASE_URL}/${API_KEY}/api/users/${id}/unlock`,
    requestOptions,
  );
  const data = await response;
  return data;
}

async function GetApiData(parameterid, inputdatasourcename, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    RequestParamType: `${parameterid}`,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/parameters/${parameterid}/inputdatasource/${inputdatasourcename}/execute`,
    requestOptions,
  );
}

async function GetDyanmicFormApiData(parameterid, data, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Accept", "application/json");

  // var raw = JSON.stringify({
  //   RequestParamType: `${data}`,

  // });

  var requestOptions = {
    method: "post",
    headers: myHeaders,
    body: JSON.stringify(data),
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/metadata/${parameterid}/execute`,
    requestOptions,
  );
}

// create metadata and parameters

async function CreateMetaData(data, token) {
  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
    redirect: "follow",
  };
  return await fetch(`${BASE_URL}/${API_KEY}/api/metadata`, requestOptions);
}

async function CreateNewParamenter(metaID, data, token) {
  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
    redirect: "follow",
  };
  console.log(requestOptions);
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/metadata/${metaID}/bulkparameters`,
    requestOptions,
  );
}

async function DeleteNewMeta(metaID, token) {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    id: `${metaID}`,
  });

  var requestOptions = {
    method: "DELETE",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const response = await fetch(
    `${BASE_URL}/${API_KEY}/api/metadata/${metaID}`,
    requestOptions,
  );
  const data = await response;
  return data;
}
//${BASE_URL}/IMSWEBAPI/api/metadata/6982dd6e-a482-4fb5-b103-2028e454a6d8/parameters

async function getParameterDetails(inputdataSource, token) {
  //var raw = JSON.stringify(paramName);

  var requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    //body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/metadata/${inputdataSource}/parameters`,
    requestOptions,
  );
}

async function getMetaDateDetails(inputdataSource, token) {
  //var raw = JSON.stringify(paramName);

  var requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    //body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/metadata/${inputdataSource}`,
    requestOptions,
  );
}

// reports download progress

async function ReportsDownload(newPayload, selctedID, token) {
  var raw = JSON.stringify({
    Type: `${newPayload}`,
  });

  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: raw,
    redirect: "follow",
    responseType: "blob", // Important
  };
  return await fetch(
    `${BASE_URL}/AKRAReportAPI/api/pms/reports/${selctedID}/download`,
    requestOptions,
  );
}

async function ClientsList(token) {
  //var raw = JSON.stringify(paramName);

  var requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    //body: raw,
    redirect: "follow",
  };
  return await fetch(`${BASE_URL}/${API_KEY}/api/clients`, requestOptions);
}

// create process
async function updateMetaData(id, payload, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(payload);

  var requestOptions = {
    method: "PUT",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/metadata/${id}`,
    requestOptions,
  );
}
async function updateParameterData(id, payload, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(payload);

  var requestOptions = {
    method: "PUT",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/parameters/${id}`,
    requestOptions,
  );
}

async function deleteParameter(id, token) {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    id: `${id}`,
  });

  var requestOptions = {
    method: "DELETE",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const response = await fetch(
    `${BASE_URL}/${API_KEY}/api/parameters/${id}`,
    requestOptions,
  );
  return response;
}

async function deleteExportParameter(id, token) {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    id: `${id}`,
  });

  var requestOptions = {
    method: "DELETE",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const response = await fetch(
    `${BASE_URL}/${API_KEY}/api/exportparameters/${id}`,
    requestOptions,
  );
  return response;
}

async function ExportParameters(payload, metaDataId, token) {
  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/metadata/${metaDataId}/bulkexportparameters`,
    requestOptions,
  );
}
async function GetExportParameters(id, token) {
  //var raw = JSON.stringify(paramName);

  var requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    //body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/metadata/${id}/exportparameters`,
    requestOptions,
  );
}
async function updateExportParameterData(id, payload, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(payload);

  var requestOptions = {
    method: "PUT",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/exportparameters/${id}`,
    requestOptions,
  );
}

async function GetMetaDataByID(id, token) {
  //var raw = JSON.stringify(paramName);

  var requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    //body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/metadata/${id}`,
    requestOptions,
  );
}

export {
  BASE_URL,
  API_KEY,
  API_REPORTS,
  FetchDataTypes,
  FetchTradeOrders,
  FetchOpenTradeOrders,
  FetchSecurityMaster,
  postTrades,
  postNewTrades,
  MetaDataList,
  MetaDataDetails,
  MetaDataDetailsExecute,
  MetaDataDetailsDownload,
  GetForgotPassword,
  GetResetPassword,
  GetChangePassword,
  CreateUser,
  GetUsersList,
  UpdateUser,
  getUserTestList,
  deleteUser,
  activateUser,
  getOpenTradeOrdersList,
  getTradeList,
  updateLockStatus,
  GetApiData,
  GetDyanmicFormApiData,
  CreateMetaData,
  CreateNewParamenter,
  DeleteNewMeta,
  getParameterDetails,
  getMetaDateDetails,
  ReportsDownload,
  ClientsList,
  updateMetaData,
  updateParameterData,
  deleteParameter,
  deleteExportParameter,
  ExportParameters,
  GetExportParameters,
  updateExportParameterData,
  GetMetaDataByID,
};
